var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('melon-header'),_c('el-carousel',{attrs:{"height":"3.4rem"}},_vm._l((_vm.carouseList),function(item){return _c('el-carousel-item',{key:item.id},[_c('img',{staticClass:"carouselImg",attrs:{"src":item.path,"alt":"婚礼堂悦动,婚礼堂,banner"},on:{"click":function($event){return _vm.toLink(item.link)}}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }